<template>
	<main-page :color="pageColor" :hide-footer="!selectedRole">
		<template v-slot:title>
			FIRST LOGIN
		</template>

		<div class="container">
			<!-- Select role -->
			<template v-if="!selectedRole">
				<h1 class="si-font mt-5 pb-0">Please Choose a Role</h1>
				<div class="d-flex flex-column align-items-center">
					<div>
						<div
							class="card mt-4 text-center clickable clickable-card limited-width si-green text-white"
							@click="pickRoleStudent"
						>
							<h1 class="py-4 px-5">
								<i class="fas mr-3" :class="{ [fs.roleIcon('STUDENT')]: true }" />Student
							</h1>
						</div>
						<div
							class="card mt-4 text-center clickable clickable-card limited-width si-blue text-white"
							@click="pickRoleTeacher"
						>
							<h1 class="py-4 px-5">
								<i class="fas mr-3" :class="{ [fs.roleIcon('TEACHER')]: true }" />Teacher
							</h1>
						</div>
						<div
							class="card mt-4 text-center clickable clickable-card limited-width si-orange text-white"
							@click="pickRolePartner"
						>
							<h1 class="py-4 px-5">
								<i class="fas mr-3" :class="{ [fs.roleIcon('PARTNER')]: true }" />Community Partner
							</h1>
						</div>
					</div>
				</div>
			</template>

			<!-- Enter code -->
			<template v-if="selectedRole">
				<div class="px-4 pb-4 mt-5">
					<label class="si-font large-label mb-4" style="font-size: 40px;">Enter Join Code:</label>
					<input
						ref="codeInput"
						class="form-control text-center black-border code-entry"
						:class="{ 'is-invalid': codeFailed }"
						v-model="code"
					/>
					<div v-if="codeFailed" class="text-danger text-lg mt-2">
						Invalid Join Code
					</div>
					<div class="mt-4">
						<button
							v-if="!joining && !validCode"
							@click="applyJoinCode()"
							class="btn btn-lg btn-no-border btn-si-gray flex"
							disabled
						>
							Join as {{ fs.roleName(selectedRole) }}
						</button>
						<button
							v-if="!joining && validCode"
							@click="applyJoinCode()"
							class="btn btn-lg btn-no-border btn-si-green flex"
						>
							Join as {{ fs.roleName(selectedRole) }}
						</button>
						<button v-if="joining" class="btn btn-lg si-btn-green text-white flex" disabled>
							Checking Code...
							<loading type="icon" />
						</button>
					</div>
				</div>
			</template>
		</div>

		<template v-slot:footer>
			<div class="col-6 text-right">
				<button class="btn btn-si-secondary" @click="backToRoleSelect">Back</button>
			</div>
		</template>
	</main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import AuthService from "@/services/AuthService";
// import Notie from "@/services/NotieService";
import Store from "@/services/Store";
import fs from "@/services/FormatService";

export default {
	name: "DistrictSelect",

	props: [],

	components: { MainPage },

	data() {
		return {
			fs: fs,
			joining: false,

			user: null,
			selectedRole: null,
			code: null,
			codeFailed: false,
		};
	},

	computed: {
		pageColor() {
			switch (this.selectedRole) {
				case "STUDENT":
					return "green";
				case "TEACHER":
					return "blue";
				case "PARTNER":
					return "orange";
				default:
					return "yellow";
			}
		},

		validCode() {
			return this.code && this.code.length == 12;
		},
	},

	watch: {
		code() {
			this.code = this.code.toUpperCase();
			this.codeFailed = false;
		},
	},

	created() {
		let role = Store.get(this, "inviteRole");
		let code = Store.get(this, "inviteCode");

		console.log("GOT ROLE & CODE", role, code);

		let autoComplete = false;
		if (role && code) {
			this.selectedRole = role;
			this.code = code;
			autoComplete = true;
		}

		AuthService.getUserNoDistrict()
			.then((r) => {
				this.user = r.data;
				if (autoComplete) {
					this.applyJoinCode();
				}
			})
			.catch((e) => {
				console.log("Error getting user", { error: e });
			});
	},

	methods: {
		pickRoleStudent() {
			this.selectedRole = "STUDENT";
		},

		pickRoleTeacher() {
			this.selectedRole = "TEACHER";
		},

		pickRolePartner() {
			this.selectedRole = "PARTNER";
		},

		applyJoinCode() {
			this.joining = true;
			AuthService.applyJoinCode(this.code, this.selectedRole)
				.then(() => {
					this.joining = false;
					AuthService.forceRefresh();
					this.goToLandingPage(this.selectedRole);
				})
				.catch((e) => {
					this.joining = false;
					console.log(e);
					this.codeFailed = true;
					this.$refs.codeInput.focus();
				});
		},

		backToRoleSelect() {
			this.selectedRole = null;
			this.code = null;
			this.codeFailed = false;
		},

		goToLandingPage(role) {
			switch (role) {
				case "STUDENT":
					this.$router.replace("/portfolio");
					break;
				case "TEACHER":
					this.$router.replace("/classes");
					break;
				case "PARTNER":
					this.$router.replace("/classes");
					break;
			}
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clickable-card {
	transition: transform 0.15s ease-in-out;
	background-color: #f7f7f7;
}
.clickable-card:hover {
	transform: scale(1.05);
}
.limited-width {
	max-width: 600px;
}
.code-entry {
	margin-left: auto;
	margin-right: auto;
	max-width: 650px;
	font-size: 72px;
	font-family: "Blender Pro";
}
.black-border {
	border: 2px solid rgb(128, 128, 128);
}
</style>
